import React, { useState, useEffect } from "react";
import { inject, observer } from "mobx-react";
import styled from "styled-components";
import axios from "axios";

const ToastMessage = inject("commonStore")(
  observer((props) => {
    const [disBox, setDisBox] = useState("flex"); //display 유무
    const [url, setUrl] = useState(""); // 해당 서버 최근 게시물 url
    useEffect(() => {
      if (
        props.commonStore.isUploaded === 1 ||
        props.commonStore.isUploaded === 2 ||
        props.commonStore.isUploaded === 3 ||
        props.commonStore.isUploaded === 4 ||
        props.commonStore.isUploaded === 5
      ) {
        // 0:없음, 1: 리데이트, 2: 포데이트, 3:relove, 4:reuniondate, 5:reunionlove
        setDisBox("flex");
        if (props.commonStore.isUploaded === 1) {
          axios({
            method: "GET",
            url: "https://back.redate.co.kr/api/column/page/1",
            responseType: "stream",
          }).then((res) => {
            setUrl(`https://main.redate.co.kr/column/${res.data[0].id}`);
          });
        } else if (props.commonStore.isUploaded === 2) {
          axios({
            method: "GET",
            url: "https://back.fordate.org/api/contents/column/page/1",
            responseType: "stream",
          }).then((res) => {
            setUrl(`https://web.fordate.org/column/${res.data[0].id}`);
          });
        } else if (props.commonStore.isUploaded === 3) {
          // id값 조회해서 url과 합성
          axios
            .get("https://relove.co.kr/wp-json/wp/v2/posts")
            .then((res) => {
              if (res.data && res.data.length > 0) {
                const link = res.data[0].link;
                setUrl(link);
              }
            })
            .catch((error) => {
              console.error("Failed to fetch posts:", error);
            });
        } else if (props.commonStore.isUploaded === 4) {
          axios
            .get("https://reuniondate.com/wp-json/wp/v2/posts")
            .then((res) => {
              if (res.data && res.data.length > 0) {
                const link = res.data[0].link;
                setUrl(link);
              }
            })
            .catch((error) => {
              console.error("Failed to fetch posts:", error);
            });
        } else if (props.commonStore.isUploaded === 5) {
          axios
            .get("https://reunionlove.co.kr/wp-json/wp/v2/posts")
            .then((res) => {
              if (res.data && res.data.length > 0) {
                const link = res.data[0].link;
                setUrl(link);
              }
            })
            .catch((error) => {
              console.error("Failed to fetch posts:", error);
            });
        }
      } else {
        setDisBox("none");
      }
    }, [props.commonStore.isUploaded]);
    const closeMessage = () => {
      setDisBox("none");
      props.commonStore.setIsUploaded(0);
    };
    return (
      <Box style={{ display: disBox }} onClick={closeMessage}>
        <span className="confirm_text">
          업로드된 칼럼(
          <a href={url} target="_blank" rel="noopener noreferrer">
            {url}
          </a>
          ) 확인하러 가실래요? 업로드에 걸리는 시간이 있어서 바로 칼럼이 안보일 때도 있습니다. 그 때는 새로고침을 해주세요!
        </span>
        <span>×</span>
      </Box>
    );
  })
);

const Box = styled.div`
  position: fixed;
  z-index: 10;
  cursor: pointer;
  line-height: 1.5;
  bottom: 200px;
  background: #ddedd0;
  width: 700px;
  box-sizing: border-box;
  padding: 20px;
  left: calc(50% - 270px);
  color: #5f8857;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);

  & a {
    color: blue;
    text-decoration: underline;
  }

  .confirm_text {
    width: 600px;
    font-size: 0.8rem;
  }

  > span:last-child {
    margin-top: -5px;
    margin-left: 10px;
    font-size: 30px;
  }
`;

export default ToastMessage;
